import httpService from "./http.service";

class CouponService {
  getCouponsUrl = "/coupons";

  getCoupons = () => {
    return httpService.get(this.getCouponsUrl);
  };
  getExportCoupons = (name) => {
    window.open(httpService.getUrl(`/coupons/excel?name=${name}`), "_blank");
// }    return httpService.get(`/coupons/excel?name=${name}`, { responseType: "blob" });
  };
  createCoupon = (model) => {
    return httpService.post("/coupons", model);
  };
  createGroupCoupon = (model) => {
    return httpService.post("/coupons/create-group", model);
  };
  editCoupon = (id, model) => {
    return httpService.patch("/coupons/" + id, model);
  };
  deleteCoupon = (id) => {
    return httpService.delete("/coupons/" + id);
  };
}

const couponService = new CouponService();
export default couponService;
